/* eslint-disable @typescript-eslint/no-unnecessary-condition */

import { CanDeactivateFn } from '@angular/router';

import { CanComponentDeactivate } from '../models/shared.models';

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
) => {
  if (component.canDeactivate) {
    return component.canDeactivate();
  }

  return true;
};
